// Realtime Socket.IO client — vehicle position/status, trip, and geofence
// events pushed live from the backend (see backend/app/websocket.py and
// app/services/realtime.py) instead of waiting on the next poll interval.
// Connection lifecycle lives here so callers (AuthContext, pages) don't each
// hold their own `socket.io-client` instance.
import { io } from "socket.io-client";
import { BASE_URL, getToken } from "./apiClient";

let socket = null;

function buildSocket() {
  return io(
    // Unlike apiClient's BASE_URL (deliberately "" in production so axios
    // prefixes relative URLs with nothing), socket.io-client parses this as
    // a connection target, not a prefix — an empty string isn't "same
    // origin" to it the way it is to axios, so it must become `undefined`
    // (io()'s own same-origin default) instead.
    BASE_URL || undefined,
    {
      autoConnect: false,
      transports: ["websocket", "polling"],
      // A function (not a plain object) so the token is re-read fresh on
      // every (re)connection attempt — the socket can outlive a login, and
      // a captured-at-construction token would keep authenticating as
      // whoever was logged in when this module first ran.
      auth: (cb) => cb({ token: getToken() }),
    }
  );
}

export function connectSocket() {
  if (!getToken()) return;
  if (!socket) socket = buildSocket();
  if (!socket.connected) socket.connect();
}

export function disconnectSocket() {
  if (socket) socket.disconnect();
}

// Subscribes `handler` to `event`; returns an unsubscribe function. Safe to
// call before the socket has connected — Socket.IO buffers the listener.
export function onRealtimeEvent(event, handler) {
  if (!socket) socket = buildSocket();
  socket.on(event, handler);
  return () => socket && socket.off(event, handler);
}
